<ul class="user-menu-nav-list">
  <menu-item
    *ngIf="currency"
    link="/settings/general/preferences"
    [isSmall]="isSmallMenu"
    icon="icon-i-money"
    ignoreActive="true"
  >
    <p class="m-0" i18n="@user.menu.currency">Currency: {{currency}}</p>
  </menu-item>
  <menu-item
    titleItem="إلى اللغة العربية"
    i18n-titleItem="@@user.menu.lang"
    icon="icon-i-globe"
    [link]="languageLink"
    [isSmall]="isSmallMenu"
    externalUrl="true"
    ignoreActive="true"
  ></menu-item>
  <menu-item
    *ngIf="isLoggedIn"
    titleItem="Logout"
    i18n-titleItem="@@user.menu.logout"
    link="/logout"
    icon="icon-i-signout"
    [isSmall]="isSmallMenu"
  ></menu-item>
</ul>
